import { Component, OnInit } from '@angular/core';
import { PatientPortalService } from 'src/app/core/services/patient-portal.service';
import { BillingProfile, BillingCardsResponse, BillingPaymentMethod } from 'src/app/core/models/patientportal';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AttchMyCardComponent } from '../attch-my-card/attch-my-card.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mybillings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mybillings.component.html',
  styleUrl: './mybillings.component.scss'
})
export class MybillingsComponent implements OnInit {

  profile: BillingProfile | null = null;
  cards: BillingCardsResponse | null = null;

  loading = false;

  // MODAL
  modalOpen = false;
  detailsLoading = false;
  selectedCards: BillingPaymentMethod[] = [];

  // 🔥 ATTACH CARD
  newPaymentMethodId = '';
  setAsDefault = true;
  attaching = false;

  constructor(private service: PatientPortalService, private modal: NgbModal) { }

  ngOnInit(): void {
    this.fetchProfile();
  }

  fetchProfile() {
    this.loading = true;

    this.service.getBillingProfile().subscribe({
      next: (res) => {
        this.profile = res.data.profile;
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  openDetails() {
    this.modalOpen = true;
    this.detailsLoading = true;

    this.service.getMyCards().subscribe({
      next: (res) => {
        this.cards = res.data;
        this.selectedCards = res.data.paymentMethods || [];
        this.detailsLoading = false;
      },
      error: () => this.detailsLoading = false
    });
  }

  closeModal() {
    this.modalOpen = false;
  }

  // 🔥 ATTACH CARD
  attachCard() {
    const pm = this.newPaymentMethodId.trim();

    if (!pm || !pm.startsWith('pm_')) {
      alert('Enter valid PaymentMethod (pm_...)');
      return;
    }

    this.attaching = true;

    this.service.attachCard({
      paymentMethodId: pm,
      setAsDefault: this.setAsDefault
    }).subscribe({
      next: () => {
        this.attaching = false;
        this.newPaymentMethodId = '';
        this.setAsDefault = true;

        // refresh
        this.openDetails();
      },
      error: () => this.attaching = false
    });
  }


  openAttachCardModal() {

    const ref = this.modal.open(AttchMyCardComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    });

    ref.componentInstance.patientId = this.profile?.patientId?._id;
    ref.componentInstance.patientName = this.profile?.patientId?.fullName;

    ref.result.then((r) => {
      if (r?.attached) {
        this.openDetails(); // refresh
      }
    });
  }

  setDefault(id: string) {
    this.service.setDefaultCard(id).subscribe(() => {
      this.openDetails();
    });
  }

  removeCard(id: string) {
    this.service.removeCard(id).subscribe(() => {
      this.openDetails();
    });
  }
}